import React from 'react';
import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { getUserData } from "../../../utils/functions";

const { Title, Paragraph } = Typography;

const containerStyle = {
    display: 'flex',
    gap: '25px',
    justifyContent: 'center',
    alignItems: 'normal',
    marginBottom: '20px'
};

const cardStyle = {
    backgroundColor: '#f6f6f6',
    borderRadius: '10px',
    padding: '22px',
    boxShadow: '0 3px 8px rgba(0, 0, 0, .2)'
};

const welcomeCardStyle = {
    ...cardStyle,
    flex: 2,
};

const upcomingCardStyle = {
    ...cardStyle,
    flex: 1,
};

const textStyle = {
    fontFamily: 'Poppins,sans-serif',
    color: '#000',
    fontSize: '14px',
    lineHeight: '20px',
    fontStyle: 'normal',
    fontWeight: '400',
    marginBottom: '1em'
};

const titleStyle = {
    fontFamily: 'Poppins,sans-serif',
    fontWeight: '600',
    color: '#000',
    fontSize: '16px',
    marginBottom: '16px',
};

const subtitleStyle = {
    fontFamily: 'Poppins,sans-serif',
    fontWeight: '600',
    color: '#000',
    fontSize: '16px',
    marginBottom: '16px',
};

const upcomingDatesStyle = {
    fontFamily: 'Poppins,sans-serif',
    color: '#000',
    fontSize: '14px',
    lineHeight: '18px',
    fontWeight: '400',
    marginBottom: '1em'
};

const linkStyle = {
    color: '#467886',
    textDecoration: 'underline',
    fontWeight: '700',
};

const WelcomeCard = () => {
    const { t } = useTranslation();
    const user = getUserData();
    const first = user?.first_name || '';
    const displayName = first ? first.charAt(0).toUpperCase() + first.slice(1) : '';

    return (
        <div style={containerStyle}>
            <div style={welcomeCardStyle}>
                <Title level={4} style={titleStyle}>
                    {t('onboarding.welcome_title', { name: displayName })}
                </Title>
                <Paragraph style={textStyle}>
                    {t('onboarding.welcome_p1')}
                </Paragraph>
                <Paragraph style={textStyle}>
                    {t('onboarding.welcome_p2')}
                </Paragraph>
                <Paragraph style={textStyle}>
                    {t('onboarding.welcome_contact_prefix')}{' '}
                    <a href="mailto:support@crg.ca" style={linkStyle}>
                        support@crg.ca
                    </a>
                </Paragraph>
            </div>

            <div style={upcomingCardStyle}>
                <Title style={subtitleStyle}>
                    {t('onboarding.upcoming_dates_title')}
                </Title>
                <Paragraph style={upcomingDatesStyle}>
                    {t('onboarding.upcoming_date_1')}
                </Paragraph>
                <Paragraph style={upcomingDatesStyle}>
                    {t('onboarding.upcoming_date_2')}
                </Paragraph>
                <Paragraph style={upcomingDatesStyle}>
                    {t('onboarding.upcoming_date_3')}
                </Paragraph>
                <Paragraph style={upcomingDatesStyle}>
                    {t('onboarding.upcoming_date_4')}
                </Paragraph>
            </div>
        </div>
    );
};
export default WelcomeCard;
